import React, { Component } from 'react'

export class HomePayBD extends React.Component<{style:any, startUp: boolean}> {
    render() {
        return null    
    }
}